// Factory function pattern to avoid Webpack TDZ issues with class inheritance
// This uses BaseAdminFactory instead of class inheritance

import { createBaseAdmin, type IBaseAdmin } from "../BaseAdminFactory";
import type { RulesGroup } from "le-coffre-resources/dist/Admin";
import type { QueryPayload } from "../../../types";
import type { IGetRulesGroupsParams } from "./RulesGroups";

interface RulesGroupsInstance {
	get(q: IGetRulesGroupsParams): Promise<RulesGroup[]>;
	getByUid(uid: string, q?: QueryPayload): Promise<RulesGroup>;
}

// Module-level singleton instance
let instance: RulesGroupsInstance | null = null;
let baseAdminInstance: IBaseAdmin | null = null;

function createRulesGroups(): RulesGroupsInstance {
	if (!baseAdminInstance) {
		baseAdminInstance = createBaseAdmin();
	}

	const baseAdmin = baseAdminInstance;
	const baseUrl = baseAdmin.namespaceUrl.concat("/rules-groups");

	return {
		get: async (q: IGetRulesGroupsParams): Promise<RulesGroup[]> => {
			const url = new URL(baseUrl);
			baseAdmin.appendJsonSearchParams(url, { q });
			try {
				return await baseAdmin.getRequest<RulesGroup[]>(url);
			} catch (err) {
				baseAdmin.onError(err);
				return Promise.reject(err);
			}
		},
		getByUid: async (uid: string, q?: QueryPayload): Promise<RulesGroup> => {
			const url = new URL(baseUrl.concat(`/${uid}`));
			if (q) baseAdmin.appendJsonSearchParams(url, q);
			try {
				return await baseAdmin.getRequest<RulesGroup>(url);
			} catch (err) {
				baseAdmin.onError(err);
				return Promise.reject(err);
			}
		},
	};
}

export function getRulesGroupsInstance(): RulesGroupsInstance {
	if (!instance) {
		instance = createRulesGroups();
	}
	return instance;
}
